// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1Ac2b","header":"ReportDetails_header__3ZouI","title":"ReportDetails_title__3tnX0","left":"ReportDetails_left__189Fo"};